import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P4-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page4/E1/Key/answerKey.png',
    component: D1,
    checkUppercase: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page4/E1/1.jpg' },
      ],
      [
        // 2
        { url: 'img/FriendsPlus/Page4/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page4/E1/3.jpg', input: true, answer: "long" },
        { url: 'img/FriendsPlus/Page4/E1/4.jpg' },
      ],
      [
        // 3
        { url: 'img/FriendsPlus/Page4/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page4/E1/6.jpg', input: true, answer: "brown" },
        { url: 'img/FriendsPlus/Page4/E1/7.jpg' },
      ],
      [
        // 4
        { url: 'img/FriendsPlus/Page4/E1/8.jpg' },
      ],
      [
        // 5
        { url: 'img/FriendsPlus/Page4/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page4/E1/10.jpg', input: true, answer: "Tim" },
        { url: 'img/FriendsPlus/Page4/E1/11.jpg' },
      ],
      [
        // 6
        { url: 'img/FriendsPlus/Page4/E1/12.jpg' },
      ],
      [
        // 7
        { url: 'img/FriendsPlus/Page4/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page4/E1/14.jpg', input: true, answer: "short" },
        { url: 'img/FriendsPlus/Page4/E1/15.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page4/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page4/E1/17.jpg', input: true, answer: "green" },
        { url: 'img/FriendsPlus/Page4/E1/18.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page4/E1/19.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page4/E1/20.jpg' },
        { url: 'img/FriendsPlus/Page4/E1/21.jpg', input: true, answer: "Billy" },
        { url: 'img/FriendsPlus/Page4/E1/22.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page4/E1/23.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page4/E1/24.jpg' },
        { url: 'img/FriendsPlus/Page4/E1/25.jpg', input: true, answer: "curly" },
        { url: 'img/FriendsPlus/Page4/E1/26.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page4/E1/27.jpg' },
      ],

    ],
  },
  2: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P4-E2',
    audio: '',
    video: '',
    component: D1,
    recorder: false,
    isAllowSubmit: false,
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page4/E2/1.jpg' },
      ],
    ]
  },


}
export default json